var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2019 0.277672C12.6713 -0.0925574 13.3287 -0.0925574 13.7981 0.277672L25.4981 9.50494C25.8148 9.75468 26 10.1387 26 10.5455V25.0455C26 26.0943 25.5891 27.1001 24.8577 27.8417C24.1263 28.5834 23.1343 29 22.1 29H3.9C2.86565 29 1.87367 28.5834 1.14228 27.8417C0.410892 27.1001 0 26.0943 0 25.0455V10.5455C0 10.1387 0.185215 9.75468 0.501877 9.50494L12.2019 0.277672ZM2.6 11.1902V25.0455C2.6 25.3951 2.73696 25.7303 2.98076 25.9775C3.22456 26.2248 3.55522 26.3636 3.9 26.3636H22.1C22.4448 26.3636 22.7754 26.2248 23.0192 25.9775C23.263 25.7303 23.4 25.3951 23.4 25.0455V11.1902L13 2.98814L2.6 11.1902Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseOutline);
export default __webpack_public_path__ + "static/media/house-outline.93c4dfb85a6feea50dd4e3e0ef24a734.svg";
export { ForwardRef as ReactComponent };